'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _softwares = require('redux/modules/softwares');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preloader = function Preloader() {
  return _react2.default.createElement(
    'div',
    { style: { textAlign: 'center' } },
    _react2.default.createElement(_components.LoadingIndicator, null)
  );
};

var SoftwareTitle = function SoftwareTitle(props) {
  return _react2.default.createElement(
    'div',
    { className: props.styles.Software__Title },
    _react2.default.createElement('img', { src: props.icon }),
    _react2.default.createElement(
      'h1',
      null,
      props.title
    )
  );
};

var Software = function Software(props) {
  var styles = props.styles,
      icon = props.icon,
      title = props.title,
      sw = props.sw;


  var latest = getLatestVersion(sw.updater);
  var older = getOlderVersions(sw.updater);
  var supportedPlatforms = [];

  // This really should be an array in the JSON, otherwise we will have to handle linux builds manually in the future
  if (latest.Url) supportedPlatforms.push('Windows');

  if (latest.UrlMac) supportedPlatforms.push('Mac');

  var buildUrl = props.selected.toLowerCase() === 'windows' ? latest.Url : latest.UrlMac;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: styles.row },
      _react2.default.createElement(SoftwareTitle, { icon: icon, title: title, styles: styles })
    ),
    _react2.default.createElement(
      'div',
      { className: styles.row },
      _react2.default.createElement(_components.Button, { primary: true, link: true, href: buildUrl, className: styles['button-padded'], label: 'Download ' + (0, _utils.prettyVersion)(latest.Version) }),
      _react2.default.createElement(_components.ButtonGroup, { styles: styles, options: supportedPlatforms, selected: props.selected, onClick: props.onClickPlatform }),
      _react2.default.createElement(
        'div',
        { style: { margin: '1em 0' } },
        _react2.default.createElement(_components.TextButton, { small: true, className: styles['button-padded'], label: 'Release notes', onClick: props.onClickLatest }),
        _react2.default.createElement(_components.TextButton, { small: true, className: styles['button-padded'], label: 'Older versions', onClick: props.onClickOlder, disabled: older.length <= 0 })
      )
    )
  );
};

var SoftwareContainer = function (_React$Component) {
  (0, _inherits3.default)(SoftwareContainer, _React$Component);

  function SoftwareContainer(props) {
    (0, _classCallCheck3.default)(this, SoftwareContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SoftwareContainer.__proto__ || (0, _getPrototypeOf2.default)(SoftwareContainer)).call(this, props));

    _this.state = {
      selectedPlatform: (0, _utils.detectOperatingSystem)()
    };
    return _this;
  }

  (0, _createClass3.default)(SoftwareContainer, [{
    key: 'onOS',
    value: function onOS(os) {
      this.setState({ selectedPlatform: os });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(Software, (0, _extends3.default)({}, this.props, { selected: this.state.selectedPlatform, onClickPlatform: this.onOS.bind(this) }));
    }
  }]);
  return SoftwareContainer;
}(_react2.default.Component);

function getLatestVersion(arr) {
  return arr[0];
}

function getOlderVersions(arr) {
  return arr.filter(function (el, index) {
    return index != 0;
  });
}

var UserDownload = (_temp = _class = function (_React$Component2) {
  (0, _inherits3.default)(UserDownload, _React$Component2);

  function UserDownload(props) {
    (0, _classCallCheck3.default)(this, UserDownload);
    return (0, _possibleConstructorReturn3.default)(this, (UserDownload.__proto__ || (0, _getPrototypeOf2.default)(UserDownload)).call(this));
  }

  (0, _createClass3.default)(UserDownload, [{
    key: 'onClickBridgeLatest',
    value: function onClickBridgeLatest() {
      this.context.dialogs.custom(_react2.default.createElement(_components.SoftwareDownloadPopupLatest, { software: 'bridge' }));
    }
  }, {
    key: 'onClickBridgeOlder',
    value: function onClickBridgeOlder() {
      this.context.dialogs.custom(_react2.default.createElement(_components.SoftwareDownloadPopupOlder, { software: 'bridge' }));
    }
  }, {
    key: 'onClickMixerLatest',
    value: function onClickMixerLatest() {
      this.context.dialogs.custom(_react2.default.createElement(_components.SoftwareDownloadPopupLatest, { software: 'mixer' }));
    }
  }, {
    key: 'onClickMixerOlder',
    value: function onClickMixerOlder() {
      this.context.dialogs.custom(_react2.default.createElement(_components.SoftwareDownloadPopupOlder, { software: 'mixer' }));
    }
  }, {
    key: 'renderUserDownloads',
    value: function renderUserDownloads() {
      var styles = require('./UserDownload.scss');

      var _props = this.props,
          bridge = _props.bridge,
          mixer = _props.mixer;


      return _react2.default.createElement(
        'div',
        { style: { overflow: 'auto' } },
        _react2.default.createElement(
          'div',
          { className: styles['col-md-12'] },
          _react2.default.createElement(SoftwareContainer, { styles: styles, icon: '/icons/bridge_64.jpg', sw: bridge, title: 'Megascans Bridge', onClickLatest: this.onClickBridgeLatest.bind(this), onClickOlder: this.onClickBridgeOlder.bind(this) }),
          _react2.default.createElement(SoftwareContainer, { styles: styles, icon: '/icons/studio_64.jpg', sw: mixer, title: 'Quixel Mixer', onClickLatest: this.onClickMixerLatest.bind(this), onClickOlder: this.onClickMixerOlder.bind(this) })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _components.InfoBox,
        { title: 'Software Downloads', icon: '/icons/license.svg' },
        this.props.loading && _react2.default.createElement(Preloader, null),
        !this.props.loading && this.props.loaded && this.renderUserDownloads()
      );
    }
  }]);
  return UserDownload;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
var UserDownloadContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    softwares: state.softwares
  };
}, null, null, { withRef: true }), _dec(_class2 = function (_React$Component3) {
  (0, _inherits3.default)(UserDownloadContainer, _React$Component3);

  function UserDownloadContainer() {
    (0, _classCallCheck3.default)(this, UserDownloadContainer);
    return (0, _possibleConstructorReturn3.default)(this, (UserDownloadContainer.__proto__ || (0, _getPrototypeOf2.default)(UserDownloadContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserDownloadContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          softwares = _props2.softwares,
          dispatch = _props2.dispatch;


      if (!softwares.bridgeLoaded) dispatch((0, _softwares.loadBridgeUpdater)());

      if (!softwares.mixerLoaded) dispatch((0, _softwares.loadMixerUpdater)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          softwares = _props3.softwares;

      var styles = require('./UserDownload.scss');

      var bridge = {
        loading: softwares.loadingBridge,
        loaded: softwares.bridgeLoaded,
        error: softwares.bridgeError,
        updater: softwares.bridgeUpdater,
        cover: softwares.bridgeCover
      };

      var mixer = {
        loading: softwares.loadingMixer,
        loaded: softwares.mixerLoaded,
        error: softwares.mixerError,
        updater: softwares.mixerUpdater,
        cover: softwares.mixerCover
      };

      var loading = bridge.loading || mixer.loading;
      var loaded = bridge.loaded && mixer.loaded;

      return _react2.default.createElement(UserDownload, { loaded: loaded, loading: loading, bridge: bridge, mixer: mixer });
    }
  }]);
  return UserDownloadContainer;
}(_react2.default.Component)) || _class2);
exports.default = UserDownloadContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserDownload/UserDownload.jsx
// module id = 2422
// module chunks = 0